import { apiClient } from '@app/api';
import { isDiarizationSegmentsEnabled } from '@app/modules/logger/screens/stream/diarization/isDiarizationSegmentsEnabled';
import { parseRangeFromTs, Station } from '@mi-front/core';
import { useQuery } from '@tanstack/react-query';
import { useDebounce } from 'use-debounce';
import { useFocus } from '../../../stores/stream-screen.store';
import TranscriptionsView from './TranscriptionsView';

interface ITranscriptionsContainer {
  station: Station;
}

const TranscriptionsContainer: React.FunctionComponent<ITranscriptionsContainer> = (props) => {
  const { station } = props;
  const focus = useFocus();
  const [debouncedFocus] = useDebounce(focus, 300);
  const range = parseRangeFromTs(debouncedFocus);

  const diarization = isDiarizationSegmentsEnabled(station);
  const { data, isLoading } = useQuery({
    queryKey: ['transcription', station.slug, range.from, range.to],

    queryFn: () =>
      apiClient.segments
        .fetchTranscription(station.slug, range.from, range.to, diarization)
        .then((res) => res),

    enabled: !!range?.from && !!range?.to,
  });

  return <TranscriptionsView data={data} loading={isLoading} station={station} />;
};

export default TranscriptionsContainer;
